











































































import CategoryResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/CategoryResponse";
import { Vue, Component, Inject } from "vue-property-decorator";
import { BREATHING_CREATE, BREATHING_EDIT } from "@/route-names";
import EventBus from "@models/eventBus";
import BreathingFilterModel from "@models/breathing/breathingFilterModel";
import { DragLiModel } from "@components/ui/models";
import SearchFilterRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Common/SearchFilterRequest";
import TranslationItemModel from "@models/translationItemModel";
import ChangeSortIndexRequest from "@/api/dataSource/api/Spirit/Common/Helpers/Models/ChangeSortIndexRequest";
import SortIndexRequest from "@/api/dataSource/api/Spirit/Common/Helpers/Models/SortIndexRequest";

@Component
export default class PageBreathingsComponent extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  filter: BreathingFilterModel = new BreathingFilterModel();
  columnNames = [
    "#",
    "Название",
    "Вдох",
    "Задержка",
    "Выход",
    "Задержка",
    "Повторов",
    "Создано",
    "Платно",
    "",
    "",
  ];
  timeFilter(time: number): string {
    if (!time) {
      return "-";
    }
    return `${time} сек`;
  }
  createRouteName = BREATHING_CREATE;
  editRouteName = BREATHING_EDIT;
  getDataFunc = this.$api.BreathingService.getListAsync.bind(
    this.$api.BreathingService
  );
  removeFunc = this.$api.BreathingService.deleteAsync.bind(
    this.$api.BreathingService
  );
  async created() {}

  async startDelete(item: CategoryResponse) {
    this.eventBus.deleteEntity.trigger({ id: item.Id });
  }

  /**
   * * Получить список для изменения порядка
   */
  async getList() {
    let self = this;
    return new Promise<Array<DragLiModel>>(async (resolve) => {
      await self.$api.BreathingService.getListAsync(
        new SearchFilterRequest()
      ).then((response) => {
        if (response.Items) {
          return resolve(
            response.Items.map(
              (x, index) =>
                new DragLiModel({
                  Id: x.Id,
                  SortIndex: index + 1,
                  Translate: x.Translations.map(
                    (t) =>
                      new TranslationItemModel({
                        langCode: t.LangCode,
                        name: `${t.CategoryName} / ${t.Name}`,
                      })
                  ),
                })
            )
          );
        } else {
          return resolve(null);
        }
      });
    });
  }

  /**
   * * Изменить порядковый индекс
   * @param items Список с измененными индексами
   */
  async changeSortIndex(items: Array<DragLiModel>) {
    let self = this;
    return new Promise<boolean>(async (resolve) => {
      await self.$api.BreathingService.changeSortIndexAsync(
        new ChangeSortIndexRequest({
          SortIndices: items.map(
            (x) =>
              new SortIndexRequest({
                Id: Number(x.Id),
                SortIndex: x.SortIndex,
              })
          ),
        })
      ).then((result) => {
        if (result) {
          this.$notification.success("Порядок успешно изменен.");
        }
        return resolve(true);
      });
    });
  }
}
